import { render } from "./UsersAndRoles.vue?vue&type=template&id=30f81c20&scoped=true"
import script from "./UsersAndRoles.vue?vue&type=script&lang=js"
export * from "./UsersAndRoles.vue?vue&type=script&lang=js"

import "./UsersAndRoles.vue?vue&type=style&index=0&id=30f81c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f81c20"]])

export default __exports__